import React from "react";
import SidebarAdmin from "../../components/SidebarAdmin";
import TopBarProfileAdmin from "../../components/TopBarProfileAdmin";
import ProfileAdmin from "../../components/ProfileAdmin";

function HalamanProfileAdmin() {
  return (
    <div className="profile-page-layout">
      {/* Sidebar kiri */}
      <SidebarAdmin />

      {/* Area kanan */}
      <div className="content">
        <TopBarProfileAdmin />

        {/* Konten utama */}
        <div className="profile-page">
          <ProfileAdmin />
        </div>
      </div>
    </div>
  );
}

export default HalamanProfileAdmin;
